import React from 'react';
import './App.css';
import { useState } from 'react';

import { Marker, InfoWindow } from "react-google-maps"

// import { Carousel } from 'react-responsive-carousel';
// import "react-responsive-carousel/lib/styles/carousel.min.css";



function Mappoints ({marker, icon}){
    const [activeMarker, setActiveMarker] = useState("")
    

 
  return(
    <>
  
      <Marker
      key={marker.id}
      icon={{ url: icon, size: {width: 50, height: 50}, anchor: {x: 15, y: 50}, scaledSize: {width: 50, height: 50}, }}
      position={{ lat: marker.latitude, lng: marker.longitude }}
      onClick = {()=> {
        setActiveMarker(marker.id);
      }}
  >
    {activeMarker === marker.id ? (
    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
      <div style={{width: "234px"}}> 
        <p style={{ fontSize: `16px`, fontColor: `black`, textAlign: `center`, fontWeight: `700`, margin: "10px" }}>{marker.shelter}</p>
                      <div style={{height: "234px", width: "234px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                          <img src={marker.images} style={{height: "234px", width: "234px", borderRadius: "7px"}}/>
                      </div>
        <p style={{ fontSize: `12px`, color: `#666666`, textAlign: `left`, fontWeight: `400`, margin: "10px", fontFamily: 'Roboto'}} >{marker.details}</p>
        <p style={{ fontSize: `12px`, color: `#666666`, textAlign: `left`, fontWeight: `400`, margin: "10px", fontFamily: 'Roboto'}} >{marker.details2}</p>
        <p style={{ fontSize: `12px`, color: `#666666`, textAlign: `left`, fontWeight: `400`, margin: "10px", fontFamily: 'Roboto'}} >{marker.details3}</p>
        <a href={marker.web} target="_blank" style={{ fontSize: `12px`, color: `#c0c099`, textAlign: `left`, fontWeight: `400`, margin: "10px", fontFamily: 'Roboto', textDecoration: 'none'}}>Zu der Webseite</a>
        <a href={marker.link} target="_blank" style={{ fontSize: `12px`, color: `#c0c099`, textAlign: `left`, fontWeight: `400`, margin: "10px", fontFamily: 'Roboto', textDecoration: 'none'}}>Zu Google Maps</a>
      </div>
      
    </InfoWindow>
     ) : null}
     
  </Marker>
    
                   
   </>
  )
}

   

export default Mappoints;
